// import React, { useState, useEffect, useRef } from "react";
// import "./style.css";
// import { useUserAuth } from "../context/UserAuthContext";
// import { Footer } from "./components/Footer";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { AddPatientButton } from "./components/AddPatientButton";
// import Spinner from "react-bootstrap/Spinner";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { WeeklyUpcomingAppointments } from "./components/WeeklyUpcomingAppointments";
// import { ProgramRenewalBtn } from "./components/ProgramRenewalBtn";
// import moment from "moment";
// import { analytics } from "../firebase/index";
// import { logEvent } from "firebase/analytics";
// import NoInternetPopup from "./components/NoInternetPopup";
// import { Platform } from "@capacitor/core";
// import search from "../images/Search.png";
// import sort from "../images/sort1.png";
// import sort1 from "../images/sort.png";
// import done from "../images/Done.png";
// import arrow from "../images/Expand Arrow.png";
// import { useIonRouter } from "@ionic/react";
// import { App } from "@capacitor/app";
// import WhatsAppButton from "./components/WhatsAppButton";
// import ImageVideoSlider from "./components/ImageVideoSlider";

// export const Home = () => {
//   const {
//     auth,
//     ID,
//     user,
//     setUser,
//     setEvent,
//     setDocEvent,
//     fetchPhysioData,
//     GetAllPhysioData,
//     patientActiveProgram,
//     getPhysioPatients,
//     fetchPatientScore,
//     fetchCompleteSlotData,
//     fetchCompleteSlotDocData,
//     updateHomePageData,
//     getAllPrograms,
//   } = useUserAuth();
//   const [userName, setUserName] = useState("");
//   const [patientsData1, setPatientsData1] = useState([]);
//   const [patientsData, setPatientsData] = useState(() => {
//     const saved = localStorage.getItem("Data");
//     if (saved) {
//       const parsed = JSON.parse(saved);
//       return Array.isArray(parsed) ? parsed : [];
//     }
//     return [];
//   });
//   const [patient, setPatient] = useState([]);
//   const [loading, setLoading] = useState(() => {
//     const saved = localStorage.getItem("Data");
//     if (saved) {
//       const parsed = JSON.parse(saved);
//       return Array.isArray(parsed) && parsed.length > 0 ? false : true;
//     }
//     return true;
//   });
//   const [scoreloading, setScoreLoading] = useState(true);
//   const [sortDescending, setSortDescending] = useState(false);
//   const [sortAescending, setSortAescending] = useState(false);
//   const [showActive, setShowActive] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showSortPopup, setShowSortPopup] = useState(false);
//   const [showActivePatients, setShowActivePatients] = useState(true);
//   const [showInactivePatients, setShowInactivePatients] = useState(true);
//   const inputRef = useRef(null);
//   const [dataUpdatedAt, setDataUpdatedAt] = useState(
//     localStorage.getItem("DataUpdatedAt") || null
//   );
//   const location = useLocation();
//   const bookedColors = ["#FADB8C", "#FADB8C", "#FADB8C", "#FADB8C"];

//   const ionRouter = useIonRouter();
//   document.addEventListener("ionBackButton", (ev) => {
//     ev.detail.register(-1, () => {
//       console.log("checking android backbutton");
//       if (!ionRouter.canGoBack()) {
//         App.exitApp();
//       }
//     });
//   });

//   const navigate = useNavigate();
//   const syncInitiated = useRef(false);

//   document.addEventListener("ionBackButton", (ev) => {
//     ev.detail.register(5, () => {
//       console.log("Another handler was called!");
//     });

//     ev.detail.register(10, (processNextHandler) => {
//       console.log("Handler was called!");

//       processNextHandler();
//     });
//   });

//   const handleSortClick = () => {
//     setSortDescending((prevSortDescending) => !prevSortDescending);
//     setSortAescending(false);
//   };

//   const handleSortClick1 = () => {
//     setSortAescending(!sortAescending);
//     setSortDescending(false);
//     console.log("this function is called ");
//     console.log("the value of sort aecending ", sortAescending);
//   };

//   const handleToggleActive = () => {
//     setShowActive(!showActive);
//   };

//   useEffect(() => {
//     console.log("Home: registering patientsUpdated listener");
//     const onPatientsUpdated = (e) => {
//       const newPatient = e.detail;
//       console.log("newpatient after add patient", newPatient);
//       setPatientsData((prev) => {
//         // avoid duplicate if already present
//         const exists = prev.some(
//           (p) =>
//             p.Patient_idFP === newPatient.Patient_idFP &&
//             newPatient.Patient_idFP !== ""
//         );
//         if (exists) return prev;
//         const updated = [newPatient, ...prev];
//         localStorage.setItem("Data", JSON.stringify(updated));
//         localStorage.setItem("DataUpdatedAt", String(Date.now()));
//         setDataUpdatedAt(localStorage.getItem("DataUpdatedAt"));
//         return updated;
//       });
//     };

//     window.addEventListener("patientsUpdated", onPatientsUpdated);
//     return () =>
//       window.removeEventListener("patientsUpdated", onPatientsUpdated);
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const ts = localStorage.getItem("DataUpdatedAt");
//       if (ts && ts !== dataUpdatedAt) {
//         setDataUpdatedAt(ts);
//         const localData = JSON.parse(localStorage.getItem("Data")) || [];
//         setPatientsData(localData);
//       }
//     }, 800); // <1s is fine; adjust as desired

//     return () => clearInterval(interval);
//   }, [dataUpdatedAt]);

//   useEffect(() => {
//     console.log("patient added through state before");
//     if (location?.state?.newPatient) {
//       const newPatient = location.state.newPatient;
//       console.log("patient added through state", newPatient);
//       setPatientsData((prev) => {
//         const exists = prev.some(
//           (p) =>
//             p.Patient_idFP === newPatient.Patient_idFP &&
//             newPatient.Patient_idFP !== ""
//         );
//         if (exists) return prev;
//         const updated = [newPatient, ...prev];
//         localStorage.setItem("Data", JSON.stringify(updated));
//         localStorage.setItem("DataUpdatedAt", String(Date.now()));
//         setDataUpdatedAt(localStorage.getItem("DataUpdatedAt"));
//         // clear location state so it doesn't reapply on future navigations
//         // (requires navigate replace if you want to clear; optional)
//         return updated;
//       });
//     }
//   }, [location]);

//   const handleSearch = (e) => {
//     const inputRect = inputRef.current.getBoundingClientRect();
//     console.log("value ", inputRect.top, window.scrollY + inputRect.top + 10);
//     window.scrollTo(0, window.scrollY + inputRect.top - 10);
//     setSearchTerm(e.target.value);
//   };

//   const handleSearchScroll = (e) => {
//     const inputRect = inputRef.current.getBoundingClientRect();
//     console.log("value ", inputRect.top, window.scrollY + inputRect.top + 10);
//     window.scrollTo(0, window.scrollY + inputRect.top - 10);
//   };
//   // useEffect(() => {
//   //   // Scroll to the top when the input bar is clicked or value changes
//   //   window.scrollTo(0, 0);
//   // }, [searchTerm]);

//   const handleFilterClick = () => {
//     setShowSortPopup(!showSortPopup);
//   };

//   const handleToggleActivePatients = () => {
//     setShowActivePatients((prev) => !prev);
//   };

//   const handleToggleInactivePatients = () => {
//     setShowInactivePatients((prev) => !prev);
//   };

//   // checking user is logged in or not , if not it will direct it to login page "/phone"
//   useEffect(() => {
//     if (!localStorage.getItem("userData")) {
//       console.log("navigation to / as we dont get userData in local");
//       navigate("/");
//     } else {
//       const checkUserData = async () => {
//         const userData = await fetchPhysioData();
//         if (!userData) {
//           console.log(
//             "navigation to / as we dont get userData in firebase , user, ",
//             ID,
//             user
//           );

//           setUser(null);
//           navigate("/");
//         }
//       };
//       checkUserData();
//     }
//   }, [user, setUser, navigate]);

//   // fetching user data
//   useEffect(() => {
//     if (user) {
//       setUserName(localStorage.getItem("py_username"));
// console.log("the value of user in home page ",user, ID, localStorage.getItem('py_username'));
//       // console.log("user details ",user);
//       const fetchData = async () => {
//         // console.log('Fetching user data...');
//         const userData = await fetchPhysioData();
//         if (userData) {
//           setUserName(userData.Name);
//         }
//         logEvent(analytics, "py_home_page_log_pydata", {
//           Date: new Date().toLocaleString(),
//           ID,
//           pyData: JSON.stringify(userData),
//           py_log: "fetching home page data for physio",
//         });
//       };

//       fetchData();
//     }
//   }, [user]);

//   const scoreCacheRef = useRef({});

//   useEffect(() => {
//     const syncPatients = async () => {
//       if (!user) return;

//       if (patientsData.length === 0) setLoading(true);

//       try {
//         // 1. Fetch the main list from server
//         const serverData = await GetAllPhysioData();

//         if (serverData) {
//           const processedServerData = serverData.map(p => ({
//             ...p,
//             PatientTotalScore: p.PatientTotalScore ?? "N/A",
//             active: p.active ?? "False"
//           }));

//           // setPatientsData(processedServerData);
//           setPatientsData((prev) => {
//             const localOnly = prev.filter(p => p.isLocalOnly);

//             const serverIds = new Set(processedServerData.map(s => s.Patient_idFP));
//             const stillLocalOnly = localOnly.filter(l => !serverIds.has(l.Patient_idFP));

//             const finalData = [...stillLocalOnly, ...processedServerData];

//             localStorage.setItem("Data", JSON.stringify(finalData));
//             return finalData;
//           });
          
//           setLoading(false);

//           // 3. Background Enrichment (Scores & Active Status)
//           // We do this without changing the "loading" state
//           processedServerData.forEach(async (patient) => {
//             const pid = patient.Patient_idFP || patient.Patient_id;
//             if (!pid) return;

//             try {
//               // Only fetch if not already cached in this session's scoreCacheRef
//               if (!scoreCacheRef.current[pid]) {
//                 const [patientScore, program] = await Promise.all([
//                   fetchPatientScore(pid),
//                   patientActiveProgram(pid),
//                 ]);

//                 const scoreValue = patientScore?.GrandTotalScore ?? "N/A";
//                 const activeValue = program?.length > 0 ? program[0].active : "False";

//                 scoreCacheRef.current[pid] = { score: scoreValue, active: activeValue };

//                 // Update state for this specific patient
//                 setPatientsData((prev) => {
//                   const updated = prev.map((p) =>
//                     (p.Patient_idFP || p.Patient_id) === pid
//                       ? { ...p, PatientTotalScore: scoreValue, active: activeValue }
//                       : p
//                   );
//                   // Update local storage so it's ready for next app launch
//                   localStorage.setItem("Data", JSON.stringify(updated));
//                   return updated;
//                 });
//               }
//             } catch (err) {
//               console.error("Background sync failed for patient:", pid);
//             }
//           });
//         }
//       } catch (err) {
//         console.error("Global sync failed:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (!syncInitiated.current) {
//       syncInitiated.current = true;
//       syncPatients();
//     }
//   }, [user]);


//   //Fetching program data and calender
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const programsData = await getAllPrograms();
//         localStorage.setItem("Program", JSON.stringify(programsData));
//         const completeSlotData = await fetchCompleteSlotData();
//         if (completeSlotData) {
//           // Process the data and convert it into events format
//           const newEvents = [];
//           for (const date in completeSlotData) {
//             completeSlotData[date].forEach((slot, index) => {
//               const isBooked = slot.ID.startsWith("booked");
//               const color = isBooked
//                 ? bookedColors[index % bookedColors.length]
//                 : undefined;
//               const eventTitle = slot.Name || "Blocked";
//               newEvents.push({
//                 id: newEvents.length + 1,
//                 ID: `${slot.ID}`,
//                 title: eventTitle,
//                 start: moment(
//                   `${date} ${slot.start}`,
//                   "DD/MM/YYYY HH:mm"
//                 ).toDate(),
//                 end: moment(`${date} ${slot.end}`, "DD/MM/YYYY HH:mm").toDate(),
//                 className: isBooked ? "booked-event" : "not-yetbooked",
//                 color: color,
//               });
//             });
//           }
//           console.log("this is actual calender event  ", newEvents);
//           localStorage.setItem("CalenderEvents", JSON.stringify(newEvents));
//           setEvent(newEvents);
//         }
//       } catch (error) {
//         console.error("Error fetching data: ", error);
//       }
//     };
//     fetchData();
//   }, [user]);

//   // fetching doc Calender Data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const completeSlotData = await fetchCompleteSlotDocData();
//         if (completeSlotData) {
//           // Process the data and convert it into events format
//           const newEvents = [];
//           for (const date in completeSlotData) {
//             completeSlotData[date].forEach((slot, index) => {
//               let isBooked = false;

//               try {
//                 isBooked = slot.ID && slot.ID.startsWith("booked");
//               } catch {
//                 isBooked = false;
//               }

//               const color = isBooked
//                 ? bookedColors[index % bookedColors.length]
//                 : undefined;
//               const eventTitle = slot.Name || "Blocked";

//               // Ensure properties exist before accessing them
//               const start = slot.start
//                 ? new Date(date + " " + slot.start)
//                 : null;
//               const end = slot.end ? new Date(date + " " + slot.end) : null;

//               newEvents.push({
//                 id: newEvents.length + 1,
//                 ID: `${slot.ID}`,
//                 title: eventTitle,
//                 start: start,
//                 end: end,
//                 className: isBooked ? "booked-event" : "not-yetbooked",
//                 color: color,
//                 appointmentType: slot.appointmentType || "",
//                 appointmentStartTime: slot.appointmentStartTime || "",
//                 day: slot.day || "",
//                 remainingMinutes: slot.remainingMinutes || "",
//                 slotDuration: slot.slotDuration || "",
//                 patientName: slot.patientname || "", // Add check for patientName
//                 patientNumber: slot.patientnumber || "", // Add check for patientNumber
//               });
//             });
//           }

//           console.log("this is actual calendar event  ", newEvents);
//           localStorage.setItem("DocCalenderEvents", JSON.stringify(newEvents));
//           // setEvents(newEvents);
//           setDocEvent(newEvents);
//         }
//       } catch (error) {
//         console.error("Error fetching data: ", error);
//       }
//     };
//     fetchData();
//   }, [user]);

//   // useEffect (() =>{
//   //   const newFetchPatientData = async () => {
//   //     const data = await GetAllPhysioData();
//   //     console.log("called single firebase function and got the data ", data);
//   //     setPatientsData(data);
//   //     setLoading(false);

//   //   }
//   //   newFetchPatientData();
//   // },[user])

//   useEffect(() => {
//     console.log("printing patients Data ", patientsData);
//   }, [patientsData]);

//   // fetching patient Score
//   // const fetchIndiPatientScore = async (patientId) => {
//   //   // console.log("fetching Scores ...")
//   //   try {
//   //     const score = await fetchPatientScore(patientId); // Implement this function to fetch the score
//   //     // console.log("Scores ",score);
//   //     return score;
//   //   } catch (error) {
//   //     console.error(`Error fetching score for patient ID ${patientId}:`, error);
//   //     return 'N/A'; // Return 'N/A' or handle the error as needed
//   //   }
//   // };

//   const handleLinkClick = (id) => {
//     console.log("logging patient data for no use");
//     // Log the patient ID when the link is clicked
//     logEvent(analytics, "py_PatientLinkClick", {
//       Date: new Date().toLocaleString(),
//       ID,
//       PatientID: id,
//       py_log: "Patient link clicked",
//     });
//   };

//   return (
//     <div className="background">
//       <br />
//       <div className="text-style">
//         <div className="name-label">
//           {userName == "" ? (
//             <Skeleton
//               width={200}
//               style={{ backgroundColor: "rgba(253, 220, 189, 0.9)" }}
//             />
//           ) : (
//             `Hi ${userName || " "}`
//           )}
//         </div>
//         {/* <br /> */}
//         {/* <ImageVideoSlider/> */}
//         <WeeklyUpcomingAppointments />

//         {/* <br /> */}
//         {/* <ProgramRenewalBtn/>                */}
//         {/* <br /> */}

//         <div className="home-main-container">
//           {/* Program Renewal Banner */}
//           <div className="mypatient-header">My Patients</div>

          
//               <img className="search-icon" src={search} alt="Search Icon" />
//               <div style={{ display: "flex" }}>
//                 <input
//                   ref={inputRef}
//                   type="text"
//                   placeholder="Search for patients"
//                   value={searchTerm}
//                   onChange={handleSearch}
//                   onClick={handleSearchScroll}
//                   className="patient-search"
//                 />

//                 <div className="filter-block" onClick={handleFilterClick}>
//                   <img
//                     src={sort}
//                     alt=""
//                     style={{ height: "35px", paddingLeft: "8%" }}
//                   />{" "}
//                   <div style={{ fontSize: "80%", fontWeight: "500" }}>
//                     {" "}
//                     Sort by{" "}
//                   </div>
//                 </div>
//               </div>

//               {showSortPopup && (
//                 <>
//                   <div className="backdrop" onClick={handleFilterClick}></div>
//                   <div className="sort-popup">
//                     {/* <p onClick={handleSortClick}>Sort by Score</p> */}
//                     {/* Add more sorting options as needed */}
//                     <div>
//                       <img
//                         src={sort1}
//                         alt=""
//                         style={{ height: "20px", paddingRight: "2%" }}
//                       />{" "}
//                       Sort By
//                     </div>
//                     <br />
//                     <div
//                       onClick={() => {
//                         handleSortClick();
//                         handleFilterClick();
//                       }}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       Score : High to Low{" "}
//                       {sortDescending && (
//                         <img
//                           style={{ height: "25px", paddingLeft: "20%" }}
//                           src={done}
//                         />
//                       )}
//                     </div>
//                     <hr />
//                     <div
//                       onClick={() => {
//                         handleSortClick1();
//                         handleFilterClick();
//                       }}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       Score : Low to High{" "}
//                       {sortAescending && (
//                         <img style={{ height: "25px" }} src={done} />
//                       )}
//                     </div>
//                   </div>
//                 </>
//               )}
// {loading ? (
//             <div className="skeleton ">
//               <Skeleton
//                 sx={{ bgcolor: "grey.900" }}
//                 variant="rectangular"
//                 className="home-loader"
//                 height={70}
//               />
//               <Skeleton
//                 sx={{ bgcolor: "grey.900" }}
//                 variant="rectangular"
//                 className="home-loader"
//                 height={70}
//               />
//               <Skeleton
//                 sx={{ bgcolor: "grey.900" }}
//                 variant="rectangular"
//                 className="home-loader"
//                 height={70}
//               />
//               <Skeleton
//                 sx={{ bgcolor: "grey.900" }}
//                 variant="rectangular"
//                 className="home-loader"
//                 height={70}
//               />
//             </div>
//           ) : (
//             <>
//               <div>
//                 <div
//                   className="mypatient-number mypatient-dropdown"
//                   onClick={handleToggleActivePatients}
//                 >
//                   <div style={{ display: "flex", paddingTop: "1%x" }}>
//                     {" "}
//                     {
//                       patientsData.filter(
//                         (patient) => patient.active === "True"
//                       ).length
//                     }{" "}
//                     <p style={{ color: "#00621B" }}> &nbsp;Active&nbsp;</p>
//                     patients{" "}
//                   </div>{" "}
//                   <img src={arrow} className="dropdownimg" />
//                 </div>
//                 {showActivePatients &&
//                   patientsData
//                     .filter((patient) =>
//                       patient.PatientNameFP.toLowerCase().includes(
//                         searchTerm.toLowerCase()
//                       )
//                     )
//                     .slice()
//                     .sort((a, b) => {
//                       if (sortDescending) {
//                         return b.PatientTotalScore - a.PatientTotalScore;
//                       } else if (sortAescending) {
//                         return a.PatientTotalScore - b.PatientTotalScore;
//                       } else {
//                         return a.PatientNameFP.localeCompare(b.PatientNameFP);
//                       }
//                     })
//                     .filter((patient) => patient.active === "True")
//                     .map((patient, index) => {
//                       const patientScore = patient.PatientTotalScore;
//                       const patientId = patient.Patient_idFP;
//                       const scoreColor =
//                         patientScore === "N/A" || parseInt(patientScore) < 30
//                           ? "red"
//                           : "green";

//                       return (
//                         <Link
//                           to={{
//                             pathname: `/patientprofile/${encodeURIComponent(
//                               patient.Patient_idFP
//                             )}/${encodeURIComponent(
//                               patient.PatientNameFP
//                             )}/${encodeURIComponent(patient.PatientMobileFP)}`,
//                             state: { patientData: patient },
//                           }}
//                           key={patient.Patient_idFP}
//                           style={{ textDecoration: "none" }}
//                           onClick={() => handleLinkClick(patient.Patient_idFP)}
//                           className="dropdown-content"
//                         >
//                           <div className="patients">
//                             <div className="patient-block1">
//                               <div className="patient-name">
//                                 {patient.PatientNameFP}
//                               </div>
//                               <div className="patient-issue">
//                                 {patient.PatientTreatmentFP}{" "}
//                               </div>
//                             </div>
//                             <div className="patient-block2">
//                               {patientScore === "N/A" ? (
//                                 <Spinner
//                                   animation="grow"
//                                   style={{ color: "#6E7382" }}
//                                 />
//                               ) : (
//                                 <>
//                                   <div
//                                     className={`${
//                                       parseInt(patientScore) < 30
//                                         ? "patient-alert"
//                                         : ""
//                                     }`}
//                                   >
//                                     {patientScore === "N/A"
//                                       ? ""
//                                       : parseInt(patientScore) < 30
//                                       ? "Low Score"
//                                       : ""}
//                                   </div>
//                                   <div
//                                     className="patient-score"
//                                     style={{ color: scoreColor }}
//                                   >
//                                     {patientScore === undefined
//                                       ? "N/A"
//                                       : `${patientScore}%`}
//                                   </div>
//                                 </>
//                               )}
//                             </div>
//                           </div>
//                         </Link>
//                       );
//                     })}
//               </div>

//               <div>
//                 <div
//                   className="mypatient-number mypatient-dropdown"
//                   onClick={handleToggleInactivePatients}
//                   style={{ paddingBottom: "2%" }}
//                 >
//                   {
//                     patientsData.filter((patient) => patient.active === "False")
//                       .length
//                   }{" "}
//                   Inactive patients <img src={arrow} className="dropdownimg" />
//                 </div>
//                 {showInactivePatients &&
//                   patientsData
//                     .filter((patient) =>
//                       patient.PatientNameFP.toLowerCase().includes(
//                         searchTerm.toLowerCase()
//                       )
//                     )
//                     .slice()
//                     .sort((a, b) => {
//                       if (sortDescending) {
//                         return b.PatientTotalScore - a.PatientTotalScore;
//                       } else if (sortAescending) {
//                         return a.PatientTotalScore - b.PatientTotalScore;
//                       } else {
//                         return a.PatientNameFP.localeCompare(b.PatientNameFP);
//                       }
//                     })
//                     .filter((patient) => patient.active === "False")
//                     .map((patient, index) => {
//                       const patientScore = patient.PatientTotalScore;
//                       const patientId = patient.Patient_idFP;
//                       const scoreColor =
//                         patientScore === "N/A" || parseInt(patientScore) < 30
//                           ? "red"
//                           : "green";

//                       return (
//                         <Link
//                           to={{
//                             pathname: `/patientprofile/${encodeURIComponent(
//                               patient.Patient_idFP
//                             )}/${encodeURIComponent(
//                               patient.PatientNameFP
//                             )}/${encodeURIComponent(patient.PatientMobileFP)}`,
//                             state: { patientData: patient },
//                           }}
//                           key={patient.Patient_idFP}
//                           style={{ textDecoration: "none" }}
//                           onClick={() => handleLinkClick(patient.Patient_idFP)}
//                           className="dropdown-content"
//                         >
//                           <div className="patients">
//                             <div className="patient-block1">
//                               <div className="patient-name">
//                                 {patient.PatientNameFP}
//                               </div>
//                               <div className="patient-issue">
//                                 {patient.PatientTreatmentFP}{" "}
//                               </div>
//                             </div>
//                             <div className="patient-block2">
//                               {patientScore === "N/A" ? (
//                                 <Spinner
//                                   animation="grow"
//                                   style={{ color: "#6E7382" }}
//                                 />
//                               ) : (
//                                 <>
//                                   <div
//                                     className={`${
//                                       parseInt(patientScore) < 30
//                                         ? "patient-alert"
//                                         : ""
//                                     }`}
//                                   >
//                                     {patientScore === "N/A"
//                                       ? ""
//                                       : parseInt(patientScore) < 30
//                                       ? "Low Score"
//                                       : ""}
//                                   </div>
//                                   <div
//                                     className="patient-score"
//                                     style={{ color: scoreColor }}
//                                   >
//                                     {patientScore === undefined
//                                       ? "N/A"
//                                       : `${patientScore}%`}
//                                   </div>
//                                 </>
//                               )}
//                             </div>
//                           </div>
//                         </Link>
//                       );
//                     })}
//               </div>
//             </>
//           )}
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//           <br />
//         </div>
//       </div>
//       <WhatsAppButton />

//       <AddPatientButton />

//       <Footer />
//     </div>
//   );
// };

import React, { useState, useEffect, useRef, useCallback } from "react";
import "./style.css";
import { useUserAuth } from "../context/UserAuthContext";
import { Footer } from "./components/Footer";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AddPatientButton } from "./components/AddPatientButton";
import Spinner from "react-bootstrap/Spinner";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { WeeklyUpcomingAppointments } from "./components/WeeklyUpcomingAppointments";
import { analytics } from "../firebase/index";
import { logEvent } from "firebase/analytics";
import NoInternetPopup from "./components/NoInternetPopup";
import search from "../images/Search.png";
import sort from "../images/sort1.png";
import sort1 from "../images/sort.png";
import done from "../images/Done.png";
import arrow from "../images/Expand Arrow.png";
import { useIonRouter } from "@ionic/react";
import { App } from "@capacitor/app";
import WhatsAppButton from "./components/WhatsAppButton";

const ENRICH_BATCH_SIZE = 5;

// Read patients from localStorage safely
const loadPatientsFromStorage = () => {
  try {
    const saved = localStorage.getItem("Data");
    if (saved) {
      const parsed = JSON.parse(saved);
      return Array.isArray(parsed) ? parsed : [];
    }
  } catch { }
  return [];
};

export const Home = () => {
  const {
    ID,
    user,
    setUser,
    fetchPhysioData,
    GetAllPhysioData,
    patientActiveProgram,
    fetchPatientScore,
  } = useUserAuth();

  const [userName, setUserName] = useState(
    () => localStorage.getItem("py_username") || ""
  );
  const [patientsData, setPatientsData] = useState(loadPatientsFromStorage);
  const [loading, setLoading] = useState(() => loadPatientsFromStorage().length === 0);
  const [sortDescending, setSortDescending] = useState(false);
  const [sortAscending, setSortAscending] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSortPopup, setShowSortPopup] = useState(false);
  const [showActivePatients, setShowActivePatients] = useState(true);
  const [showInactivePatients, setShowInactivePatients] = useState(true);

  const inputRef = useRef(null);
  const syncInitiated = useRef(false);
  const scoreCacheRef = useRef({});
  const enrichAbortRef = useRef(false); // ✅ FIX: lets us cancel enrichment if component unmounts

  const ionRouter = useIonRouter();
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ FIX: Register ionBackButton listener only once, not on every render
  useEffect(() => {
    const handler = (ev) => {
      ev.detail.register(-1, () => {
        if (!ionRouter.canGoBack()) App.exitApp();
      });
    };
    document.addEventListener("ionBackButton", handler);
    return () => document.removeEventListener("ionBackButton", handler);
  }, [ionRouter]);

  // ✅ FIX: Removed setInterval localStorage polling — replaced with storage event
  useEffect(() => {
    const handler = () => {
      setPatientsData(loadPatientsFromStorage());
    };
    window.addEventListener("storage", handler);
    // Also listen for the custom patientsUpdated event
    const onPatientsUpdated = (e) => {
      const newPatient = e.detail;
      setPatientsData((prev) => {
        const exists = prev.some(
          (p) => p.Patient_idFP && p.Patient_idFP === newPatient.Patient_idFP
        );
        if (exists) return prev;
        const updated = [newPatient, ...prev];
        localStorage.setItem("Data", JSON.stringify(updated));
        localStorage.setItem("DataUpdatedAt", String(Date.now()));
        return updated;
      });
    };
    window.addEventListener("patientsUpdated", onPatientsUpdated);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener("patientsUpdated", onPatientsUpdated);
    };
  }, []);

  // Handle patient passed via navigation state
  useEffect(() => {
    if (location?.state?.newPatient) {
      const newPatient = location.state.newPatient;
      setPatientsData((prev) => {
        const exists = prev.some(
          (p) => p.Patient_idFP && p.Patient_idFP === newPatient.Patient_idFP
        );
        if (exists) return prev;
        const updated = [newPatient, ...prev];
        localStorage.setItem("Data", JSON.stringify(updated));
        localStorage.setItem("DataUpdatedAt", String(Date.now()));
        return updated;
      });
    }
  }, [location]);

  // Auth guard
  useEffect(() => {
    if (!localStorage.getItem("userData")) {
      navigate("/");
      return;
    }
    const checkUserData = async () => {
      const userData = await fetchPhysioData();
      if (!userData) {
        setUser(null);
        navigate("/");
      }
    };
    checkUserData();
  }, [user, setUser, navigate, fetchPhysioData]);

  // Fetch physio name
  useEffect(() => {
    if (!user) return;
    const fetchData = async () => {
      const userData = await fetchPhysioData();
      if (userData) {
        setUserName(userData.Name);
        logEvent(analytics, "py_home_page_log_pydata", {
          Date: new Date().toLocaleString(),
          ID,
          py_log: "fetching home page data for physio",
        });
      }
    };
    fetchData();
  }, [user]);

  // ✅ FIX: Batched background enrichment — avoids 100 simultaneous requests
  const enrichPatientsBatched = useCallback(async (patients) => {
    enrichAbortRef.current = false;
    for (let i = 0; i < patients.length; i += ENRICH_BATCH_SIZE) {
      if (enrichAbortRef.current) break; // Stop if unmounted

      const batch = patients.slice(i, i + ENRICH_BATCH_SIZE);
      await Promise.allSettled(
        batch.map(async (patient) => {
          const pid = patient.Patient_idFP || patient.Patient_id;
          if (!pid || scoreCacheRef.current[pid]) return;

          try {
            const [patientScore, program] = await Promise.all([
              fetchPatientScore(pid),
              patientActiveProgram(pid),
            ]);
            const scoreValue = patientScore?.GrandTotalScore ?? "N/A";
            const activeValue = program?.length > 0 ? program[0].active : "False";
            scoreCacheRef.current[pid] = { score: scoreValue, active: activeValue };

            if (!enrichAbortRef.current) {
              setPatientsData((prev) => {
                const updated = prev.map((p) =>
                  (p.Patient_idFP || p.Patient_id) === pid
                    ? { ...p, PatientTotalScore: scoreValue, active: activeValue }
                    : p
                );
                localStorage.setItem("Data", JSON.stringify(updated));
                localStorage.setItem("DataUpdatedAt", String(Date.now()));
                return updated;
              });
            }
          } catch (err) {
            console.error("Enrichment failed for patient:", pid, err);
          }
        })
      );
    }
  }, [fetchPatientScore, patientActiveProgram]);

  // Main patient sync — runs once per mount
  useEffect(() => {
    if (!user || syncInitiated.current) return;
    syncInitiated.current = true;

    const syncPatients = async () => {
      try {
        const serverData = await GetAllPhysioData();
        if (!serverData) return;

        const processed = serverData.map((p) => ({
          ...p,
          PatientTotalScore: p.PatientTotalScore ?? "N/A",
          active: p.active ?? "False",
        }));

        setPatientsData((prev) => {
          const localOnly = prev.filter(
            (p) => p.isLocalOnly && !processed.some((s) => s.Patient_idFP === p.Patient_idFP)
          );
          const finalData = [...localOnly, ...processed];
          localStorage.setItem("Data", JSON.stringify(finalData));
          localStorage.setItem("DataUpdatedAt", String(Date.now()));
          return finalData;
        });

        setLoading(false);

        // ✅ FIX: Enrichment is now batched, not all-at-once
        enrichPatientsBatched(processed);
      } catch (err) {
        console.error("Patient sync failed:", err);
      } finally {
        setLoading(false);
      }
    };

    syncPatients();

    // ✅ FIX: Cancel in-flight enrichment when component unmounts
    return () => { enrichAbortRef.current = true; };
  }, [user, GetAllPhysioData, enrichPatientsBatched]);

  // Handlers
  const handleSortClick = () => { setSortDescending((v) => !v); setSortAscending(false); };
  const handleSortClick1 = () => { setSortAscending((v) => !v); setSortDescending(false); };
  const handleFilterClick = () => setShowSortPopup((v) => !v);
  const handleToggleActivePatients = () => setShowActivePatients((v) => !v);
  const handleToggleInactivePatients = () => setShowInactivePatients((v) => !v);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      window.scrollTo(0, window.scrollY + rect.top - 10);
    }
  };

  const handleLinkClick = (id) => {
    logEvent(analytics, "py_PatientLinkClick", {
      Date: new Date().toLocaleString(),
      ID,
      PatientID: id,
      py_log: "Patient link clicked",
    });
  };

  // Shared sort + filter logic to avoid duplication
  const getSortedPatients = (activeStatus) =>
    patientsData
      .filter((p) => p.PatientNameFP?.toLowerCase().includes(searchTerm.toLowerCase()))
      .filter((p) => p.active === activeStatus)
      .slice()
      .sort((a, b) => {
        if (sortDescending) return (b.PatientTotalScore || 0) - (a.PatientTotalScore || 0);
        if (sortAscending) return (a.PatientTotalScore || 0) - (b.PatientTotalScore || 0);
        return (a.PatientNameFP || "").localeCompare(b.PatientNameFP || "");
      });

  // Shared patient card renderer
  const renderPatientCard = (patient) => {
    const patientScore = patient.PatientTotalScore;
    const scoreColor = patientScore === "N/A" || parseInt(patientScore) < 30 ? "red" : "green";
    return (
      <Link
        to={{
          pathname: `/patientprofile/${encodeURIComponent(patient.Patient_idFP)}/${encodeURIComponent(patient.PatientNameFP)}/${encodeURIComponent(patient.PatientMobileFP)}`,
          state: { patientData: patient },
        }}
        key={patient.Patient_idFP}
        style={{ textDecoration: "none" }}
        onClick={() => handleLinkClick(patient.Patient_idFP)}
        className="dropdown-content"
      >
        <div className="patients">
          <div className="patient-block1">
            <div className="patient-name">{patient.PatientNameFP}</div>
            <div className="patient-issue">{patient.PatientTreatmentFP}</div>
          </div>
          <div className="patient-block2">
            {patientScore === "N/A" ? (
              <Spinner animation="grow" style={{ color: "#6E7382" }} />
            ) : (
              <>
                {parseInt(patientScore) < 30 && (
                  <div className="patient-alert">Low Score</div>
                )}
                <div className="patient-score" style={{ color: scoreColor }}>
                  {`${patientScore}%`}
                </div>
              </>
            )}
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div className="background">
      <br />
      <div className="text-style">
        <div className="name-label">
          {userName === "" ? (
            <Skeleton width={200} style={{ backgroundColor: "rgba(253, 220, 189, 0.9)" }} />
          ) : (
            `Hi ${userName}`
          )}
        </div>

        <WeeklyUpcomingAppointments />

        <div className="home-main-container">
          <div className="mypatient-header">My Patients</div>

          <img className="search-icon" src={search} alt="Search Icon" />
          <div style={{ display: "flex" }}>
            <input
              ref={inputRef}
              type="text"
              placeholder="Search for patients"
              value={searchTerm}
              onChange={handleSearch}
              className="patient-search"
            />
            <div className="filter-block" onClick={handleFilterClick}>
              <img src={sort} alt="" style={{ height: "35px", paddingLeft: "8%" }} />
              <div style={{ fontSize: "80%", fontWeight: "500" }}>Sort by</div>
            </div>
          </div>

          {showSortPopup && (
            <>
              <div className="backdrop" onClick={handleFilterClick}></div>
              <div className="sort-popup">
                <div>
                  <img src={sort1} alt="" style={{ height: "20px", paddingRight: "2%" }} />
                  Sort By
                </div>
                <br />
                <div onClick={() => { handleSortClick(); handleFilterClick(); }}
                  style={{ display: "flex", justifyContent: "space-between" }}>
                  Score: High to Low
                  {sortDescending && <img style={{ height: "25px", paddingLeft: "20%" }} src={done} />}
                </div>
                <hr />
                <div onClick={() => { handleSortClick1(); handleFilterClick(); }}
                  style={{ display: "flex", justifyContent: "space-between" }}>
                  Score: Low to High
                  {sortAscending && <img style={{ height: "25px" }} src={done} />}
                </div>
              </div>
            </>
          )}

          {loading ? (
            <div className="skeleton">
              {[70, 70, 70, 70].map((h, i) => (
                <Skeleton key={i} variant="rectangular" className="home-loader" height={h} />
              ))}
            </div>
          ) : (
            <>
              {/* Active Patients */}
              <div>
                <div className="mypatient-number mypatient-dropdown" onClick={handleToggleActivePatients}>
                  <div style={{ display: "flex", paddingTop: "1%" }}>
                    {patientsData.filter((p) => p.active === "True").length}
                    <p style={{ color: "#00621B" }}>&nbsp;Active&nbsp;</p>patients
                  </div>
                  <img src={arrow} className="dropdownimg" />
                </div>
                {showActivePatients && getSortedPatients("True").map(renderPatientCard)}
              </div>

              {/* Inactive Patients */}
              <div>
                <div className="mypatient-number mypatient-dropdown" onClick={handleToggleInactivePatients}
                  style={{ paddingBottom: "2%" }}>
                  {patientsData.filter((p) => p.active === "False").length} Inactive patients
                  <img src={arrow} className="dropdownimg" />
                </div>
                {showInactivePatients && getSortedPatients("False").map(renderPatientCard)}
              </div>
            </>
          )}

          {/* Spacer */}
          {Array.from({ length: 12 }).map((_, i) => <br key={i} />)}
        </div>
      </div>

      <WhatsAppButton />
      <AddPatientButton />
      <Footer />
    </div>
  );
};